import { useRef } from 'react';
import isEqual from 'lodash/isEqual';

interface DeepMemo<T> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  key: any;
  value: T;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDeepMemo<T = any>(memoFn: any, key: any) {
   
  const ref = useRef<DeepMemo<T>>();
  if (!ref.current || !isEqual(key, ref?.current?.key)) {
    ref.current = { key, value: memoFn() };
  }

  return ref.current.value;
}
